<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#fff"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g transform="translate(-19 -208)">
      <rect width="16" height="16" transform="translate(19 208)" fill="none" />
      <g transform="translate(-4 -10)">
        <g>
          <rect
            width="6.641"
            height="6.641"
            rx="1"
            transform="translate(24 219)"
          />
          <rect
            width="6.641"
            height="6.641"
            rx="1"
            transform="translate(24 226.359)"
          />
          <rect
            width="6.641"
            height="6.641"
            rx="1"
            transform="translate(31.359 219)"
          />
        </g>
        <path
          fill="#fff"
          d="M1,0H5.641a1,1,0,0,1,1,1V5.641a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0Z"
          transform="translate(31.359 226.359)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "attr-icon",
};
</script>

<style scoped></style>
